import { render } from "./TestEdit.vue?vue&type=template&id=35298466&scoped=true"
import script from "./TestEdit.vue?vue&type=script&lang=js"
export * from "./TestEdit.vue?vue&type=script&lang=js"

import "./TestEdit.vue?vue&type=style&index=0&id=35298466&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35298466"]])

export default __exports__